import { render, staticRenderFns } from "./notif.vue?vue&type=template&id=18d67b8c&scoped=true&"
import script from "./notif.vue?vue&type=script&lang=js&"
export * from "./notif.vue?vue&type=script&lang=js&"
import style0 from "./notif.vue?vue&type=style&index=0&id=18d67b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d67b8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18d67b8c')) {
      api.createRecord('18d67b8c', component.options)
    } else {
      api.reload('18d67b8c', component.options)
    }
    module.hot.accept("./notif.vue?vue&type=template&id=18d67b8c&scoped=true&", function () {
      api.rerender('18d67b8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/sys/notification/notif.vue"
export default component.exports